import React, { useState, useEffect } from "react";
import { Table, TableBody, TableCell, TableRow, Button } from "@material-ui/core";
import { TableCellClass, TableRowProps, initialState } from "../constants";
import { useGetLocalizationLabel, useFetchHubParamsData } from "../useAPIMethods";
import { ViewTableContainer, HyperLinkDiv, HubParamModal, ModelBodyDiv, HeaderTitle, CertDetailsTable, FooterButtons, EditActions, BackButtonContainer, EditNodeButton } from "../styled";
import { useDateTimeByUserFormat } from "utils";
import { MdClose } from "react-icons/md";
import { Header } from "semantic-ui-react";
import moment from "moment";
import { FaArrowLeft } from "react-icons/fa";
import APIutil from "api/APIutils";
import * as url from "api/url";
import { Table as ReactData } from "reactstrap";
import EditNodeDetails from "./EditNodeDetails";


const ViewNodeDetails = ({ networkId, OnCancel, networkList, getNetworkList, connectionStatus}) => {

    const { getLabel } = useGetLocalizationLabel();
    const { getDateTimeValue } = useDateTimeByUserFormat();
    const [state, setState] = useState(initialState);
    const [apiData, setapiData] = useState(null);
    const [issuerCertData, setIssuerCertData] = useState(null);
    const [operCertData, setOperCertData] = useState(null);
    const [onCertClicked, setOnCertClicked] = useState(false);
    const [isEditClicked, setIsEditClicked] = useState(false);
    const { data } = useFetchHubParamsData();
    const [tableData, setTableData] = useState(null);
    const ViewNodeDetails =true;
    const ensembleVmac = sessionStorage.getItem('ensembleVmac');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await APIutil.getDataAPI(`${url.post_secure_network_link}/${networkId}`);
                setapiData(response);
                if (response) {
                    if (response.rootCertificateSubjectName) {
                        getIssuerCertDetails(networkId);
                        if (response.operationalCertificateSubjectName) {
                            getOperCertDetails(networkId);
                        }

                    } else if (response.operationalCertificateSubjectName) {
                        getOperCertDetails(networkId);
                    }
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        const fetchTableData = async () => {
            try {
                const response = await APIutil.getDataAPI(`${url.get_NetworkDetailList + "/" + networkId}`);
                if (response && Array.isArray(response)) {
                    const updatedResponse = JSON.parse(JSON.stringify(response));
                    updatedResponse.map(rowData => {
                        const timeZone = timeZoneAbbreviated(rowData.lastConnectedDate);
                        rowData["lastConnectedDate"] = `${moment(rowData.lastConnectedDate).format("MMM/DD/YYYY h:mm A")} ${timeZone}`;
                        return rowData;
                    });
                    setTableData(updatedResponse);
                }
            }
            catch (error) {
                console.error('Error fetching data:', error)
            }
        }

        fetchTableData();
        fetchData();
    }, []);

    const timeZoneAbbreviated = (datestring) => {
        const { 1: tz } = new Date(datestring).toString().match(/\((.+)\)/);
        if (tz.includes(" ")) {
            return tz
                .split(" ")
                .map(([first]) => first)
                .join("");
        } else {
            return tz;
        }
    };

    const getIssuerCertDetails = async () => {
        try {
            const response = await APIutil.getDataAPI(`${url.get_root_cert_details}/${networkId}`);
            setIssuerCertData(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const getOperCertDetails = async () => {
        try {
            const response = await APIutil.getDataAPI(`${url.get_operational_cert_details}/${networkId}`);
            setOperCertData(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const onSort = (column) => {
        setState(prevState => ({
            ...prevState,
            isDefaultSort: false
        }));
        var SortData = state.sort.direction;
        var selected = SortData.filter(a => a.name === column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = tableData;
        let notequals = 0;
        let sortedData;
        if (data_from_state != null && column !== "deviceID") {
            sortedData = data_from_state.sort((a, b) => {
                let nameA = a[column].toLowerCase();
                let nameB = b[column].toLowerCase();

                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA === nameB) {
                    return 0;
                }
                return 0;
            });
        }
        else {
            sortedData = data_from_state.sort((a, b) => {
                let nameA = a[column];
                let nameB = b[column];

                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA === nameB) {
                    return 0;
                }

                return 0;
            });
        }
        if (selected[0].direction === 'asc' && notequals === 1) {
            sortedData.reverse();
        }

        const array = state.sort.direction;
        array.map(x => (x.name === column) ? x.onclick = true : x.onclick = false);
        array.map(x => (x.name === column) ? x.direction = direction : x.direction);
        setState(prevState => ({
            ...prevState,
            sort: {
                column,
                direction: array
            }
        }));

    };

    

    const onClickCertificateName = (certificateId) => {
        setState(prevState => ({ ...prevState, selectedCertificate: certificateId }));
        setOnCertClicked(true);
    }

    const onToggleModel = () => {
        setState(prevState => ({
            ...prevState,
        }));
        setOnCertClicked(false);
    }

    const getCertificateName = (originalName, onlyName) => {
        let updatedName = originalName;
        if (updatedName) {
            if (updatedName.split(" ")[0].includes("CN=")) {
                updatedName = updatedName.split(" ")[0].replace("CN=", "").replace(",", "");
            } else {
                updatedName = updatedName.split(" ")[1].replace("CN=", "").replace(",", "");
            }
            if (onlyName) {
                updatedName = `${updatedName}`;
            } else {
                updatedName = `${getLabel("CertificateDetails") ? getLabel("CertificateDetails") : "Certificate Details for"} ${updatedName}`;
            }
        } else {
            updatedName = "--";
        }
        return updatedName;
    }

    const showCertificateDetails = () => {
        const { selectedCertificate } = state;
        let title = "--", certificateName = "--";
        const details = (selectedCertificate === "issuerCert" && issuerCertData) ? issuerCertData :
            (selectedCertificate === "operationalCert" && operCertData) ? operCertData : null;
        if (selectedCertificate === "issuerCert") {
            title = getCertificateName(apiData.rootCertificateSubjectName);
            certificateName = apiData.rootCertificateSubjectName ? apiData.rootCertificateSubjectName : "--";
        } else if (selectedCertificate === "operationalCert") {
            title = getCertificateName(apiData.operationalCertificateSubjectName);
            certificateName = apiData.operationalCertificateSubjectName ? apiData.operationalCertificateSubjectName : "--";
        }
        return (
            <ModelBodyDiv>
                <HeaderTitle id="header-title">
                    <div onClick={onToggleModel}><MdClose /></div>
                    <label>{title}</label>
                </HeaderTitle>
                <CertDetailsTable>
                    <tbody>
                        <tr>
                            <td>{getLabel("DistinguishedName") ? getLabel("DistinguishedName") : "Distinguished Name"}</td><td>{certificateName}</td>
                        </tr>
                        <tr>
                            <td>{getLabel("IssuedBy") ? getLabel("IssuedBy") : "Issued By"}</td><td>{apiData ? apiData.rootCertificateSubjectName : "--"}</td>
                        </tr>
                        <tr>
                            <td>{getLabel("NotBefore") ? getLabel("NotBefore") : "Not Before"}</td><td>{details ? getDateTimeValue(details.validFrom) : "--"}</td>
                        </tr>
                        <tr>
                            <td>{getLabel("NotAfter") ? getLabel("NotAfter") : "Not After"}</td><td>{details ? getDateTimeValue(details.validTo) : "--"}</td>
                        </tr>
                        <tr>
                            <td>{getLabel("Thumbprint") ? getLabel("Thumbprint") : "Thumbprint"}</td><td>{details ? details.thumbprint : "--"}</td>
                        </tr>
                    </tbody>
                </CertDetailsTable>
                <FooterButtons id="model-footer-section">
                    <EditActions>
                        <Button id="cancel_button" variant="contained" onClick={onToggleModel}>{getLabel("Close") ? getLabel("Close") : "Close"}</Button>
                    </EditActions>
                </FooterButtons>
            </ModelBodyDiv>
        );
    }

    // const getConnetionStatusLabel = () => {
    //     if (apiData && apiData.isNodeConnected) {
    //         return "Connected"
    //     } else if (apiData && !apiData.isEnabled) {
    //         return "Disabled"
    //     } else if (apiData && apiData.rootCertificateSubjectName && apiData.operationalCertificateSubjectName) {
    //         return "Connected to Primary Hub"
    //     } else {
    //         return "Enabled"
    //         // <div >{"Enabled"}
    //         //     <Icon name='exclamation triangle' style={{ 'color': 'red', 'padding-left': '8px', 'padding-right': '14px', 'padding-top': '0px' }} />
    //         //     <span style={{ 'color': 'red' }} >missing certificates</span>
    //         // </div>
    //     }
    // }

    const FormTableData = () => {
        let UpdatedTableData = tableData;
        if (tableData && tableData.length > 0) {
            if (state.isDefaultSort) {
                UpdatedTableData.sort((a, b) => {
                    let nameA = a['nodeVMAC'].toLowerCase();
                    let nameB = b['nodeVMAC'].toLowerCase();

                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    if (nameA === nameB) {
                        return 0;
                    }
                    return 0
                });
            }
        }
        return (
            <> {
                tableData && tableData.length ? tableData.map(el => (
                    <tr key={el.nodeVMAC}>
                        <td style={{ padding: "10px" }}>
                            {el.nodeVMAC}
                        </td>
                        <td style={{ padding: "10px" }}>{el.deviceID ? el.deviceID : ""}</td>
                        <td style={{ padding: "10px" }}>{el.nodeVMAC === ensembleVmac ? "Tracer Ensemble" : el.deviceName ? el.deviceName : ""}</td>
                        <td style={{ padding: "10px" }}>{el.lastConnectedDate ? el.lastConnectedDate : ""}</td>
                        <td style={{ padding: "10px" }}>{el.statusDescription ? el.statusDescription : ""}</td>
                    </tr>

                )) : <tr> <td colSpan="5" style={{ textAlign: "center" }}>{getLabel("NoRecords") ? getLabel("NoRecords") : "No Records Found"}</td> </tr>}
            </>
        )

    };

    const getTlsVersionLabel = () => {
        if (apiData && apiData.tlsVersion && data.tlsOptions && data.tlsOptions.length) {
            const modeObject = data.tlsOptions.find((item) => item.value === apiData.tlsVersion[0]);
            const modeObject1 = data.tlsOptions.find((item) => item.value === apiData.tlsVersion[1]);
            const label1 = modeObject && modeObject.label ? modeObject.label : "--";
            const label2 = modeObject1 && modeObject1.label ? modeObject1.label : modeObject && modeObject.label ? modeObject.label : "--";
            return (<div>
                <span style={{ color: "#333333", fontWeight: "600" }}>Min: </span> {label1}
                <span style={{ color: "#333333", fontWeight: "600", paddingLeft: "33px" }}>Max: </span> {label2}
            </div>);
        } else {
            return "--";
        }
    };

    const getModeLabel = () => {
        return (
            <div>
                {apiData && getLabel("CreateNode." + apiData.mode) ? getLabel("CreateNode." + apiData.mode) : "Node"}
            </div>
        )
    }

    const RedirecrtToEditNode = () => {
        setState(prevState => ({
            ...prevState,
        }));
        setIsEditClicked(true);
    }

    return (
        <div>
           {isEditClicked ? <EditNodeDetails networkList={networkList} OnCancel={OnCancel} networkId={networkId} issuerCertData={issuerCertData} operCertData={operCertData} getNetworkList={getNetworkList} apiData={apiData} isEdit= {ViewNodeDetails}/>:
           <>
               <ViewTableContainer>
                <Header className='workordermainheaderlbl' id="viewnetwork-headerlabel">
                    {getLabel("HeaderTitle") ? getLabel("HeaderTitle") : "Manage Secure Connect BACnet Network"}
                    &nbsp; - <b style={{ fontFamily: "Verdana" }}> {apiData && apiData.networkName ? apiData.networkName : "--"} </b>
                </Header>

                <Table size="small" aria-label="simple table" id="view-hub-params-table" className={`material-ui-table`}>
                    <TableBody className="material-ui-table-body">
                        <TableRow {...TableRowProps}>
                            <TableCell {...TableCellClass}>{apiData && apiData.isEnabled ?
                                getLabel("Enabled") ? getLabel("Enabled") : "Enabled" :
                                getLabel("Disabled") ? getLabel("Disabled") : "Disabled"}
                            </TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <BackButtonContainer>
                                <Button variant="contained" id="edit-button" onClick={RedirecrtToEditNode} >{getLabel("Edit") ? getLabel("Edit") : "Edit"}</Button>
                            </BackButtonContainer>
                        </TableRow>

                        <TableRow {...TableRowProps}>
                            <TableCell {...TableCellClass}>{getLabel("LinkMode") ? getLabel("LinkMode") : "Link Mode"}</TableCell>
                            <TableCell {...TableCellClass}>
                                {getModeLabel()}
                            </TableCell>
                        </TableRow>

                        {/* <TableRow {...TableRowProps}>
                            <TableCell {...TableCellClass}>{getLabel("BACnetNetworkNumber") ? getLabel("BACnetNetworkNumber") : "BACnet Network Number"}</TableCell>
                            <TableCell {...TableCellClass}>
                                {apiData && apiData.networkNumber ? Number(apiData.networkNumber) : "--"}
                            </TableCell>
                        </TableRow> */}

                        <TableRow {...TableRowProps}>
                            <TableCell {...TableCellClass}>{getLabel("VMAC") ? getLabel("VMAC") : "VMAC"}</TableCell>
                            <TableCell {...TableCellClass}>{apiData && apiData.vmac ? apiData.vmac : "--"}</TableCell>
                        </TableRow>

                        <TableRow {...TableRowProps}>
                            <TableCell {...TableCellClass}>{getLabel("IssuerCertificate") ? getLabel("IssuerCertificate") : "Issuer Certificate"}</TableCell>
                            <TableCell {...TableCellClass}>
                                {apiData && apiData.rootCertificateSubjectName ? <HyperLinkDiv id="issuercert-link" onClick={() => onClickCertificateName("issuerCert")}>
                                    {apiData.rootCertificateSubjectName}</HyperLinkDiv> : "--"}
                            </TableCell>
                            <TableCell {...TableCellClass}><label>{getLabel("ExpiresOnCamelCase") ? getLabel("ExpiresOnCamelCase") : "Expires On"}</label></TableCell>
                            <TableCell {...TableCellClass}>{issuerCertData && issuerCertData.validTo ? getDateTimeValue(issuerCertData.validTo) : "--"}</TableCell>
                        </TableRow>

                        <TableRow {...TableRowProps}>
                            <TableCell {...TableCellClass}>{getLabel("OperationalCertificate") ? getLabel("OperationalCertificate") : "Operational Certificate"}</TableCell>
                            <TableCell {...TableCellClass}>
                                {apiData && apiData.operationalCertificateSubjectName ? <HyperLinkDiv id="operationalcert-link" onClick={() => onClickCertificateName("operationalCert")}>
                                    {apiData.operationalCertificateSubjectName}</HyperLinkDiv> : "--"}
                            </TableCell>
                            <TableCell {...TableCellClass}><label>{getLabel("ExpiresOnCamelCase") ? getLabel("ExpiresOnCamelCase") : "Expires On"}</label></TableCell>
                            <TableCell {...TableCellClass}>{operCertData && operCertData.validTo ? getDateTimeValue(operCertData.validTo) : "--"}</TableCell>
                        </TableRow>

                        <TableRow {...TableRowProps}>
                            <TableCell {...TableCellClass}>{getLabel("PrimaryHubURL") ? getLabel("PrimaryHubURL") : "Primary Hub URL"}</TableCell>
                            <TableCell {...TableCellClass}>
                                {(apiData && apiData.primaryHubURL) ? (apiData.mode !== 0 && apiData.endPointUrl === (apiData.primaryHubURL.replace(apiData.primaryHubURL.split(":")[1], apiData.endPointUrl.split(":")[1]) + '/' + apiData.networkName)) ? apiData.primaryHubURL + '/' + apiData.networkName : apiData.primaryHubURL : "--"}
                            </TableCell>
                        </TableRow>

                        <TableRow {...TableRowProps}>
                            <TableCell {...TableCellClass}>{getLabel("FailoverHubURL") ? getLabel("FailoverHubURL") : "Failover Hub URL"}</TableCell>
                            <TableCell {...TableCellClass}>{(apiData && apiData.failOverHubURL) ? (apiData.mode !== 0 && apiData.endPointUrl === (apiData.failOverHubURL.replace(apiData.failOverHubURL.split(":")[1], apiData.endPointUrl.split(":")[1]) + '/' + apiData.networkName)) ? apiData.failOverHubURL + '/' + apiData.networkName : apiData.failOverHubURL : "--"}</TableCell>
                        </TableRow>

                        <TableRow {...TableRowProps}>
                            <TableCell {...TableCellClass}> {getLabel("ConnectionStatus") ? getLabel("ConnectionStatus") : "Connection Status"}</TableCell>
                            <TableCell {...TableCellClass}>{connectionStatus} </TableCell>
                        </TableRow>

                        <TableRow {...TableRowProps}>
                            <TableCell {...TableCellClass}>{getLabel("TLSVersionAllowed") ? getLabel("TLSVersionAllowed") : "TLS Version Allowed"}</TableCell>
                            <TableCell {...TableCellClass}>{getTlsVersionLabel()}</TableCell>
                        </TableRow>

                        <TableRow {...TableRowProps}>
                            <TableCell {...TableCellClass}> {getLabel("ConnectionTimout") ? getLabel("ConnectionTimout") : "Connection Timeout (seconds)"}</TableCell>
                            <TableCell {...TableCellClass}> {apiData && apiData.connectionTimeOut ? Number(apiData.connectionTimeOut) : "--"}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </ViewTableContainer>
            {onCertClicked && (
                <HubParamModal
                    isOpen={!state.isModelOpen}>
                    {showCertificateDetails()}
                </HubParamModal>)}
            { apiData && apiData.mode !== 0 ? 
                <div className="table_container" style={{ width: "80%", marginLeft: "35px", marginBottom: "50px" }}>
                    <ReactData id="table_Holidays" striped responsive className="Custom_table table_border">
                        <tbody className="cell_container tenant_cell">
                            <tr>
                                <th className="link_cursor" style={{ padding: "9px" }} onClick={() => { onSort('nodeVMAC') }} >

                                    {getLabel("NodeVMAC") ? getLabel("NodeVMAC") : "Node VMAC"}
                                    <span className={(state.sort !== undefined && state.sort.direction[0] !== undefined && state.sort.direction[0].name === "nodeVMAC") ?
                                        (state.sort.direction[0].onclick) ? (state.sort.direction[0].direction === "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                            : (state.sort.direction[0].direction === "desc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th className="link_cursor" style={{ padding: "9px" }} onClick={() => { onSort('deviceID') }}>

                                    {getLabel("DeviceID") ? getLabel("DeviceID") : "Device ID"}
                                    <span className={(state.sort !== undefined && state.sort.direction[1] !== undefined && state.sort.direction[1].name === "deviceID") ?
                                        (state.sort.direction[1].onclick) ? (state.sort.direction[1].direction === "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                            : (state.sort.direction[1].direction === "desc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th className="link_cursor" style={{ padding: "8px 10px" }} onClick={() => { onSort('deviceName') }}>
                                    {getLabel("DeviceName") ? getLabel("DeviceName") : "Device Name"}
                                    <span className={(state.sort !== undefined && state.sort.direction[2] !== undefined && state.sort.direction[2].name === "deviceName") ?
                                        (state.sort.direction[2].onclick) ? (state.sort.direction[2].direction === "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                            : (state.sort.direction[2].direction === "desc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>

                                </th>
                                <th className="link_cursor" style={{ padding: "9px" }} onClick={() => { onSort('lastConnectedDate') }}>

                                    {getLabel("LastConnectedDate") ? getLabel("LastConnectedDate") : "Last Connected Date"}
                                    <span className={(state.sort !== undefined && state.sort.direction[3] !== undefined && state.sort.direction[3].name === "lastConnectedDate") ?
                                        (state.sort.direction[3].onclick) ? (state.sort.direction[3].direction === "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                            : (state.sort.direction[3].direction === "desc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th className="link_cursor" style={{ padding: "8px 10px" }} onClick={() => { onSort('statusDescription') }}>

                                    {getLabel("Status") ? getLabel("Status") : "Status"}
                                    <span className={(state.sort !== undefined && state.sort.direction[4] !== undefined && state.sort.direction[4].name === "statusDescription") ?
                                        (state.sort.direction[4].onclick) ? (state.sort.direction[4].direction === "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                            : (state.sort.direction[4].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                            </tr>
                            {
                                FormTableData()
                            }
                        </tbody>
                    </ReactData>
                </div> : null
            }

            <span style={{ marginLeft: "30px", marginTop: "50px" }}>
                <EditNodeButton variant="contained" id="button" onClick={OnCancel}>
                    <FaArrowLeft /> {getLabel("Back") ? getLabel("Back") : "Back"}
                </EditNodeButton>
            </span>
           </>
           }
        </div>
    );
}

export default ViewNodeDetails;